import { render } from "./VolunteerPermissionsPage.vue?vue&type=template&id=e244e2d0"
import script from "./VolunteerPermissionsPage.vue?vue&type=script&lang=js"
export * from "./VolunteerPermissionsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__